if (!customElements.get('stack-builder')) {
  customElements.define(
    'stack-builder',
    class StackBuilder extends HTMLElement {
      constructor() {
        super();

        this.tier1Qty = parseInt(this.dataset.tier1Qty, 10);
        this.tier1Percent = parseInt(this.dataset.tier1Percent, 10);
        this.tier2Qty = parseInt(this.dataset.tier2Qty, 10);
        this.tier2Percent = parseInt(this.dataset.tier2Percent, 10);
        this.eligibleProductIds = this.dataset.productIds.split(',').map((id) => id.trim());

        this.bar = this.querySelector('[data-stack-bar]');
        this.messageEl = this.querySelector('[data-stack-message]');
        this.countEl = this.querySelector('[data-stack-count]');
        this.subtotalEl = this.querySelector('[data-stack-subtotal]');
        this.tierNodes = this.querySelectorAll('[data-tier-node]');
        this.tiles = Array.from(this.querySelectorAll('.stack-tile'));

        this.tiles.forEach((tile) => {
          tile.addEventListener('click', this.onTileClick.bind(this));
        });

        this.refreshFromCart();
      }

      onTileClick(evt) {
        const tile = evt.currentTarget;
        if (tile.classList.contains('loading') || tile.hasAttribute('disabled')) return;

        tile.classList.add('loading');

        const body = new FormData();
        body.append('id', tile.dataset.variantId);
        body.append('quantity', 1);
        body.append('sections', 'cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.messageEl.textContent = response.description || response.message || 'No se pudo añadir el producto.';
              return;
            }

            this.updateCartIconBubble(response.sections);
            this.refreshFromCart();
          })
          .catch(() => {
            this.messageEl.textContent = 'Hubo un problema de conexión. Intenta de nuevo.';
          })
          .finally(() => {
            tile.classList.remove('loading');
          });
      }

      refreshFromCart() {
        fetch(`${window.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => this.updateFromCart(cart))
          .catch(() => {});
      }

      updateFromCart(cart) {
        const eligibleItems = cart.items.filter((item) =>
          this.eligibleProductIds.includes(String(item.product_id))
        );

        const totalQty = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);
        const subtotal = eligibleItems.reduce((sum, item) => sum + item.final_line_price, 0);

        this.updateTileBadges(eligibleItems);
        this.updateBar(totalQty, subtotal);
      }

      updateTileBadges(eligibleItems) {
        this.tiles.forEach((tile) => {
          const item = eligibleItems.find((i) => String(i.product_id) === tile.dataset.productId);
          const badge = tile.querySelector('.stack-tile__badge');
          const qty = item ? item.quantity : 0;
          badge.textContent = qty;
          badge.hidden = qty === 0;
          tile.classList.toggle('stack-tile--active', qty > 0);
        });
      }

      updateBar(totalQty, subtotal) {
        this.countEl.textContent = totalQty === 1 ? '1 unidad' : `${totalQty} unidades`;
        this.subtotalEl.textContent = totalQty > 0 ? this.formatMoney(subtotal) : '';

        this.tierNodes.forEach((node) => {
          const step = parseInt(node.dataset.tierNode, 10);
          const reached =
            step === 0 || (step === 1 && totalQty >= this.tier1Qty) || (step === 2 && totalQty >= this.tier2Qty);
          node.classList.toggle('is-reached', reached);
        });

        if (totalQty === 0) {
          this.messageEl.textContent = 'Empieza a armar tu stack — cada click añade una unidad.';
        } else if (totalQty >= this.tier2Qty) {
          this.messageEl.innerHTML = `${totalQty} unidades · <strong>-${this.tier2Percent}% aplicado.</strong> Descuento máximo.`;
        } else if (totalQty >= this.tier1Qty) {
          const remaining = this.tier2Qty - totalQty;
          this.messageEl.innerHTML = `<strong>-${this.tier1Percent}% aplicado.</strong> Suma ${remaining} más para el -${this.tier2Percent}%.`;
        } else {
          const remaining = this.tier1Qty - totalQty;
          this.messageEl.innerHTML = `Suma ${remaining} más para desbloquear el <strong>-${this.tier1Percent}%</strong>.`;
        }

        this.bar.classList.toggle('has-items', totalQty > 0);
      }

      formatMoney(cents) {
        return `$${(cents / 100).toFixed(2)}`;
      }

      updateCartIconBubble(sections) {
        const html = sections && sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (parsed) bubble.innerHTML = parsed.innerHTML;
      }
    }
  );
}
